@for (priority of priorities; track priority) {
  <div
    class="priorityButton__row"
    (click)="selectOption(priority)"
    >
    <pp-priority-button [ppPriority]="priority"> </pp-priority-button>
  </div>
}
